"use client";

import Link from "next/link";

export default function TradingViewIndicators() {
  return (
    <section className="relative">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="py-12 md:py-20">
          {/* Section header */}
          <div className="mx-auto max-w-3xl pb-12 text-center md:pb-20">
            <h1 className="animate-[gradient_6s_linear_infinite] bg-[linear-gradient(to_right,var(--color-gray-200),var(--color-indigo-200),var(--color-gray-50),var(--color-indigo-300),var(--color-gray-200))] bg-[length:200%_auto] bg-clip-text pb-4 font-nacelle text-4xl font-semibold text-transparent md:text-5xl">
              TradingView İndikatörlerimiz
            </h1>
            <p className="text-lg text-indigo-200/65">
              Profesyonel trading deneyimimizle geliştirdiğimiz özel indikatörler sayesinde
              daha doğru ve karlı kararlar vermenize yardımcı oluyoruz.
            </p>
          </div>

          <div className="mx-auto max-w-4xl">
            <div className="mb-12 space-y-8 text-indigo-200/75">
              <h2 className="text-2xl font-semibold text-indigo-100">Bulut İndikatörü</h2>
              <p>
                NF Kripto'nun özel geliştirdiği <span className="font-semibold text-indigo-300">Bulut İndikatörü</span>, 
                piyasadaki trend değişimlerini ve kritik destek-direnç noktalarını tespit etmek için tasarlanmış 
                yenilikçi bir analiz aracıdır. Farklı zaman dilimlerindeki fiyat hareketlerini analiz ederek, gelecekteki 
                olası fiyat seviyelerini tahmin eder ve görsel olarak kullanıcıya sunar.
              </p>
              
              <h3 className="text-xl font-semibold text-indigo-200">Bulut İndikatörünün Özellikleri</h3>
              <ul className="list-inside list-disc pl-4 space-y-2">
                <li>
                  <span className="font-semibold">Dinamik Destek-Direnç Seviyeleri:</span> Fiyatın hareket ettiği 
                  dinamik destek ve direnç seviyelerini gerçek zamanlı olarak hesaplar ve görselleştirir. 
                  Bu seviyeler, fiyat hareketleri değiştikçe otomatik olarak güncellenir.
                </li>
                <li>
                  <span className="font-semibold">Trend Tanımlama:</span> Mevcut trendin yönünü ve gücünü 
                  belirleyerek, bulut rengini buna göre değiştirir. Yeşil renkli bulut yükselen trendi, 
                  kırmızı renkli bulut ise düşen trendi gösterir.
                </li>
                <li>
                  <span className="font-semibold">Gelecek Tahminleri:</span> Mevcut momentumu ve fiyat
                  hareketlerini analiz ederek, gelecekteki olası fiyat bölgelerini tahmin eder. Bu tahminler,
                  bulutun genişliği ile gösterilir.
                </li>
                <li>
                  <span className="font-semibold">Çoklu Zaman Dilimi Analizi:</span> Farklı zaman dilimlerindeki 
                  fiyat hareketlerini birleştirerek daha kapsamlı bir analiz sunar, böylece kısa ve uzun vadeli 
                  trendleri aynı anda görmenizi sağlar.
                </li>
                <li>
                  <span className="font-semibold">Volatilite Ölçümü:</span> Kripto paranın volatilitesini ölçerek 
                  bulut kalınlığını buna göre ayarlar. Yüksek volatilite durumunda bulut daha kalın, düşük 
                  volatilitede ise daha ince görünür.
                </li>
              </ul>
              
              <h3 className="text-xl font-semibold text-indigo-200">Bulut İndikatörü Nasıl Kullanılır?</h3>
              <p>
                Bulut İndikatörü, hem yeni başlayan hem de deneyimli traderlar için kolaylıkla kullanılabilecek 
                şekilde tasarlanmıştır. Yeşil bulutun üst sınırı potansiyel direnç seviyesini, alt sınırı ise 
                potansiyel destek seviyesini gösterir. Fiyat, bulutun üst sınırını geçerse, yükseliş trendinin 
                güçlendiği; alt sınırın altına düşerse, düşüş trendinin başladığı anlaşılır.
              </p>
              
              <p>
                Optimal alım noktaları için yeşil bulutun alt sınırına yakın bölgeleri, satım noktaları için ise 
                bulutun üst sınırına yakın bölgeleri değerlendirebilirsiniz. Bulutun kalınlaşması, volatilitenin 
                arttığını ve daha geniş stop-loss seviyeleri kullanmanız gerektiğini gösterir.
              </p>

              <h2 className="text-2xl font-semibold text-indigo-100">Gelecekte Eklenmesi Planlanan İndikatörler</h2>
              <p>
                NF Kripto ekibi olarak, sürekli olarak yeni indikatörler geliştirmekte ve mevcut indikatörlerimizi 
                iyileştirmekteyiz. Yakında yayınlamayı planladığımız diğer özel indikatörler:
              </p>
              
              <ul className="list-inside list-disc pl-4 space-y-2">
                <li>
                  <span className="font-semibold">Balina Algılayıcı:</span> Onchain verileri kullanarak büyük hacimli 
                  alım-satımları grafiğe yansıtan ve balina aktivitelerini görselleştiren indikatör.
                </li>
                <li>
                  <span className="font-semibold">Trend Gücü Ölçer:</span> Mevcut trendin gücünü ve sürdürülebilirliğini 
                  ölçen, birden fazla zaman dilimindeki momentumu birleştiren gelişmiş bir indikatör.
                </li>
                <li>
                  <span className="font-semibold">Volatilite Tahmincisi:</span> Geçmiş volatilite verilerini analiz ederek 
                  gelecekteki olası volatilite artışlarını tahmin eden ve buna göre optimal stop-loss seviyeleri öneren indikatör.
                </li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-indigo-100">İndikatörlerimize Nasıl Erişebilirsiniz?</h2>
              <p>
                NF Kripto'nun özel geliştirdiği tüm TradingView indikatörlerine erişmek ve bunları kendi grafiklerinizde 
                kullanmak için Telegram kanalımıza katılabilirsiniz. Kanal üyelerimize, bu profesyonel trading araçlarını 
                nasıl etkili bir şekilde kullanacakları konusunda detaylı eğitimler ve sürekli destek sunuyoruz.
              </p>
              
              <div className="mt-10 flex justify-center">
                <Link
                  href="/telegram-cryptofour"
                  className="inline-block text-center"
                >
                  <span className="block bg-gradient-to-r from-indigo-600 to-indigo-500 p-0.5 rounded-lg text-white shadow-[0_0_15px_rgba(99,102,241,0.5)] transition-all duration-300 hover:shadow-[0_0_25px_rgba(99,102,241,0.8)]">
                    <span className="block bg-gray-900/90 px-5 py-2.5 rounded-md backdrop-blur-sm transition-all hover:bg-gray-900/70">
                      <span className="relative inline-flex items-center">
                        İndikatörlere Erişin
                        <span className="ml-1 tracking-normal text-white/50 transition-transform group-hover:translate-x-0.5">
                          -&gt;
                        </span>
                      </span>
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 